import { render, staticRenderFns } from "./ShowReward.vue?vue&type=template&id=3ce79b66"
import script from "./ShowReward.vue?vue&type=script&lang=js"
export * from "./ShowReward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports